import { render, staticRenderFns } from "./Sanctions.vue?vue&type=template&id=73f44928"
import script from "./Sanctions.vue?vue&type=script&lang=js"
export * from "./Sanctions.vue?vue&type=script&lang=js"
import style0 from "./Sanctions.vue?vue&type=style&index=0&id=73f44928&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports